export const loginStateSelector = (state) => state?.loginState
